import React from "react";
import { Button } from "react-bootstrap";

// Represents an individual row in the table, handles rendering of table columns for the row, and checkbox functionality for item selection.
function TableItem(props) {
  function checkHandler() {
    // when checked, call the function passed to the selectedItemCallback prop.
    // used to pass data to the Table component for managing selected items - RH.
    if (props.selectedItemCallback !== undefined) {
      props.selectedItemCallback(props.data)
    }
  }

  // function to render checkbox if the showCheckbox prop is true
  function renderCheckbox() {
    // if showCheckBox prop is true, show the checkbox - RH
    if (props.showCheckbox) {
      return (
        <td><input type="checkbox" onChange={checkHandler}></input></td>
      );
    } 
  }

  // render table columns based on data and hiddenColumns props
  function renderTableColumns() {
    return (Object.entries(props.data)  // gets key-value pairs from the TableItem's data.
      .filter((entry) => { return !props.hiddenColumns.includes(entry[0]) }) // filter out hidden columns
      .map((entry) => { // runs the following code on each entry :)
        if (Object.keys(props.preRenderCallbacks).includes(entry[0])) { // if a preRenderCallback exists for a column 
          return ( // if the callback exists, use it to render the column value
            <td key={entry[0]}>{props.preRenderCallbacks[entry[0]](entry[1])}</td>
          )
        } else { // if no preRenderCallback exists, render the value directly
          return (
            <td key={entry[0]}>{entry[1]}</td>
            
          )
        }
      })
    )
  }
  //Function to render the delete button in the last column of the row
  function renderDeleteButton() {
    if (props.handleDelete) {
      return (
        <td>
          <Button
          variant="success"
          size="sm"
          onClick={()=> props.handleDelete(props.data.id)} //call delete function when clicked
          >
            Delete
          </Button>
        </td>
      );
    } else {
      return null;
    }
  }

  // returns the JSX for a table row, including rendered columns and checkbox if applicable
  return ( 
    <tr key={props.data.id} className="QuizItem">{/* todo: need to rename the QuizItem CSS class, it's not just for quizzes lol - RH */}
      {renderTableColumns()}
      {renderCheckbox()}
      {renderDeleteButton()}
    </tr>
  );
}

export default TableItem;

TableItem.defaultProps = {
  selectedItemCallback: undefined,
  hiddenColumns: [],
  preRenderCallbacks: {},
  showCheckbox: false,
  data: {},
  handleDelete: undefined
};